function infiniteQueryOptions(options) {
  return options;
}

export { infiniteQueryOptions };
//# sourceMappingURL=infiniteQueryOptions.mjs.map
